"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrescriptionPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var paper_sign_png_1 = __importDefault(require("../../../assets/prescription/paper_sign.png"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var upload_1 = require("./upload");
var view_1 = require("./view");
var react_redux_1 = require("react-redux");
var sign_in_required_1 = require("../../components/sign_in_required");
var PrescriptionPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_1.useState)("upload"), activeTab = _a[0], setActiveTab = _a[1];
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    (0, react_1.useEffect)(function () {
        //
    }, []);
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null, user._id ? (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
            react_1.default.createElement("img", { src: paper_sign_png_1.default, className: "w-full object-cover max-h-80" }),
            react_1.default.createElement("div", { className: "flex flex-rows justify-center gap-8" },
                react_1.default.createElement("div", { className: "flex flex-row justify-center items-center cursor-pointer gap-2 text-primary ".concat(activeTab == "upload" ? "border-b-4 rounded border-primary" : ""), onClick: function () {
                        setActiveTab("upload");
                    } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faFileArrowUp, size: "xl" }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Upload Script", textColor: "text-primary", size: "2xlarge" })),
                react_1.default.createElement("div", { className: "flex flex-row justify-center items-center cursor-pointer gap-2 text-primary ".concat(activeTab == "view" ? "border-b-4 rounded border-primary" : ""), onClick: function () {
                        setActiveTab("view");
                    } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faEye, size: "xl" }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "View Scripts", textColor: "text-primary", size: "2xlarge" }))),
            activeTab == "upload" ? react_1.default.createElement(upload_1.UploadPrescriptionPage, null) : react_1.default.createElement(view_1.ViewPrescriptionPage, null))) : (react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null)))));
};
exports.PrescriptionPage = PrescriptionPage;
